/* Prints a complete HTML document through a hidden iframe, so the admin page
   itself isn't what gets printed. Same approach as the public booking form's
   PDF button (components/form.js), plus a wait for web fonts: the application
   forms print Devanagari, and printing before the font arrives falls back to
   whatever the machine has. "Save as PDF" in the print dialog gives a PDF. */
export function printHtml(html, documentTitle = "") {
  const frame = document.createElement("iframe");
  frame.setAttribute("title", documentTitle || "print");
  Object.assign(frame.style, {
    position: "fixed",
    left: "-10000px",
    top: "0",
    width: "794px",
    height: "1123px",
    border: "0",
    opacity: "0",
  });
  document.body.appendChild(frame);

  const win = frame.contentWindow;
  const doc = win?.document;
  const remove = () => frame.parentNode && frame.parentNode.removeChild(frame);
  if (!win || !doc) {
    remove();
    return false;
  }

  doc.open();
  doc.write(html);
  doc.close();

  /* The browser names the saved PDF after the top page's title. */
  const originalTitle = document.title;
  if (documentTitle) document.title = documentTitle;
  const restore = () => {
    document.title = originalTitle;
    remove();
  };
  win.onafterprint = restore;

  const fontsReady = doc.fonts?.ready || Promise.resolve();
  /* Never hang on a font that doesn't load (offline, blocked CDN). */
  const timeout = new Promise((resolve) => setTimeout(resolve, 3000));
  Promise.race([fontsReady, timeout]).then(() => {
    setTimeout(() => {
      win.focus();
      win.print();
      setTimeout(restore, 1000);
    }, 300);
  });
  return true;
}

/* Opens a complete HTML document in a new tab to read, without printing —
   e.g. an earlier, cancelled revision of a bill. False if a popup blocker
   stopped the tab opening. */
export function viewHtml(html) {
  const win = window.open("", "_blank");
  if (!win) return false;
  win.document.open();
  win.document.write(html);
  win.document.close();
  return true;
}
